export default function FormatRichText (text) {
  let description = text.replace(/<\/?(img|a)[^>]*>/gi, '');
  description = description.replace(/(\n)/g, "");
  description = description.replace(/(\t)/g, "");
  description = description.replace(/(\r)/g, "");
  description = description.replace(/<\/?[^>]*>/g, "");
  description = description.replace(/\s*/g, "");
  return description
}